/// <amd-module name="typeahead/core/SuggestionFactory"/>

import {EssSuggestion} from "typeahead/core/EssSuggestion";
import {GeolocationSuggestion} from "typeahead/core/geolocation/GeolocationSuggestion";
import {GoogleMapsSuggestion} from "typeahead/core/google/GoogleMapsSuggestion";
import {ISuggestionResult, Suggestion, SuggestionCategory} from "typeahead/core/Suggestion";

export function createSuggestion(suggestionResult: ISuggestionResult, hasChild: boolean = false): Suggestion {
    if (SuggestionCategory[SuggestionCategory.GEOLOCATION] === suggestionResult.category) {
        return new GeolocationSuggestion(suggestionResult);
    } else if (SuggestionCategory[SuggestionCategory.GOOGLEMAPS] === suggestionResult.category) {
        return new GoogleMapsSuggestion(suggestionResult);
    } else {
        return new EssSuggestion(suggestionResult, hasChild);
    }
}
